import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { NavService } from '../../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Agrupacion } from '../../../_models/agrupacion';
import { AgrupacionService } from '../../../_services/agrupacion.service';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { EstructuraFisica } from '../../../_models/estructura-fisica';
import { GrupoService} from '../../../_services/grupo.service';
import { EstructuraFisicaService } from '../../../_services/estructura-fisica.service';
import { Grupo } from '../../../_models/grupo';
import { UsuariosProcesosService } from '../../../_services/usuarios-procesos.service';
import { forkJoin } from 'rxjs';
import { UsuarioProceso } from '../../../_models/usuario-proceso';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { EstructuraFisicaUsuariosProcesosService } from '../../../_services/estructura-fisica-usuarios-procesos.service';
import { EstructuraFisicaUsuariosProcesos } from '../../../_models/estructura-fisica-usuarios-procesos';

@Component({
  selector: "app-asignar-grupos",
  templateUrl: "asignar-grupos.component.html",
})
export class AsignarGruposComponent implements OnInit {
  estructuraFisica: EstructuraFisica;
  carInformacionInicial = true;
  cargaInicialFinalizada = false;
  grupos: Grupo[] = [];
  columnas: any[];
  columnas2: any[];
  busqueda: string;
  @ViewChild("dt") tabla: Table;
  @ViewChild("dtEstructuras") tablaEstructura: Table;
  menu: Funcionalidad = new Funcionalidad();
  lisUsuariosProcesosTodos: UsuarioProceso[] =  [];
  lisUsuariosProcesos: SelectItem[] = [];
  estructurasFisicasUsuariosProcesosTodos: EstructuraFisicaUsuariosProcesos[] =  [];
  estructurasFisicasUsuariosProcesosFiltrados: EstructuraFisicaUsuariosProcesos[] = [];
  formulario: FormGroup;
  isSwitchOn: boolean = false;
  submitted = false
  carTabla = true;

  constructor(
    private agrServicio: AgrupacionService,
    private navServicio: NavService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private estructuraFisicaServicio: EstructuraFisicaService,
    private grupoServicio: GrupoService,
    private autServicio: AutenticacionService,
    private usuariosProcesosService: UsuariosProcesosService,
    private estructuraFisicaUsuariosProcesosService: EstructuraFisicaUsuariosProcesosService
  ) {}

  ngOnInit(): void {
    // this.tabla.filterGlobal( this.busqueda, 'contains' );
    /*
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'dor/agrupacion' );
    if ( mn ) {
      this.menu = mn;
    }
  */
    this.route.params.subscribe((params: Params) => {
      if (
        params["id"] !== "" &&
        params["id"] !== null &&
        params["id"] !== undefined
      ) {
        /**Obtenemos la estructura física*/
        this.estructuraFisicaServicio
          .getById(params["id"])
          .subscribe((estructuraFisica) => {
            this.estructuraFisica = estructuraFisica;
            this.isSwitchOn = this.estructuraFisica.indicadorRestriccionAprobacion;
            if (this.estructuraFisica) {
              /**Obtenemos los grupos relacionados a la estructura física*/
              this.grupoServicio
                .obtenerPorIdEstructuraFisca(
                  this.estructuraFisica.idEstructuraFisica
                )
                .subscribe(async (resGrupos) => {
                  this.grupos = resGrupos;

                  await this.cargarInformacionNivelAprobacion();
                  this.carInformacionInicial = false;
                });
            }
          });
      }
    });

    this.columnas = [
      {
        field: "codigo",
        header: this.navServicio.buscarMensaje("GRUPO.LBL_CODIGO"),
        sort: false,
      },
      {
        field: "nombreGrupo",
        header: this.navServicio.buscarMensaje("GRUPO.LBL_NOMBREGRUPO"),
        sort: false,
      },
      {
        field: "nombreGerenteOficina",
        header: this.navServicio.buscarMensaje(
          "GRUPO.LBL_NOMBREGERENTEOFICINA"
        ),
        sort: false,
      },
      {
        field: "indicadorHabilitado",
        header: this.navServicio.buscarMensaje("LBL_HABILITADO"),
        sort: false,
      },
      {
        field: "det",
        header: this.navServicio.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];
    this.columnas2 = [
      {
        field: "nombreApellido",
        header: this.navServicio.buscarMensaje("ESTRUCTURAFISICA.LBL_USUARIO"),
        sort: false,
      },
      {
        field: "rol",
        header: this.navServicio.buscarMensaje("ESTRUCTURAFISICA.LBL_ROL"),
        sort: false,
      },
      {
        field: "nivel",
        header: this.navServicio.buscarMensaje(
          "ESTRUCTURAFISICA.LBL_NIVEL"
        ),
        sort: false,
      },
      {
        field: "nivelRango",
        header: this.navServicio.buscarMensaje("ESTRUCTURAFISICA.LBL_RANGOAPROBACION"),
        sort: false,
      },
      {
        field: "montoAprobacion",
        header: this.navServicio.buscarMensaje("ESTRUCTURAFISICA.LBL_MAXAPROBACION"),
        sort: false,
      },
      {
        field: "tipoAprobacion",
        header: this.navServicio.buscarMensaje("ESTRUCTURAFISICA.LBL_TIPOAPROBACION"),
        sort: false,
      },
      {
        field: "det",
        header: this.navServicio.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];
    this.busqueda = this.navServicio.getSearch( 'asignar-grupos.component' );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idEstructuraFisicaUsuarioProceso: [ null , [] ],
      idEstructuraFisica: [ this.estructuraFisica.idEstructuraFisica , [] ],
      idsUsuarioProceso: [ [], [Validators.required] ],
      indicadorHabilitado: [ true ]
    } );
  }

  crear() {
    this.router.navigate([
      "apl/estructura-fisica/asignar-grupo/" +
        this.estructuraFisica.idEstructuraFisica +
        "/agregar",
    ]);
  }

  async guardarEstructuraFisicaUsuarioProcesos(registro: EstructuraFisicaUsuariosProcesos[], inhabilitar = false) {
    this.carTabla = true;
    await this.estructuraFisicaUsuariosProcesosService.bulk(registro).toPromise();
    await this.actualizarTablaYListados();
    this.actualizarPaginadoTabla();
    inhabilitar ? this.navServicio.setMesage( 2 ) : this.navServicio.setMesage( 1 );
    this.submitted = false;
  }

  async inhabilitarRegistro(row: EstructuraFisicaUsuariosProcesos) {
    this.confirmationService.confirm( {
      message: this.navServicio.buscarMensaje('MSG_INHABILITAR'),
      header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'confirmacion',
      accept: async () => {
        row.indicadorHabilitado = false;
        await this.guardarEstructuraFisicaUsuarioProcesos([row], true);
      },
      reject: () => {
      }
    } );

  }

  actualizarPaginadoTabla() {
    const pagina = this.tablaEstructura.first > 0 ? ( this.tablaEstructura.first / 10 ) + 1 : 1;
    setTimeout( () => {
      const canPagina = this.tablaEstructura.totalRecords > 0 ? ( Math.floor( ( this.tablaEstructura.totalRecords - 1 ) / 10 ) ) + 1 : 1;
      if ( pagina > canPagina ) {
        this.tablaEstructura.first = pagina > 1 ? ( pagina - 2 ) * 10 : 0;
      }
    }, 5 );
  }

  async agregarEstructuraFisicaUsuarioProceso() {
    this.submitted = true;
    if(this.formulario.valid) {
      let registroBulk: EstructuraFisicaUsuariosProcesos[] = [];
      this.f.idsUsuarioProceso.value.map((idUsuarioProceso) => {
        const registro = {} as EstructuraFisicaUsuariosProcesos;
        registro.indicadorHabilitado = true;
        registro.idEstructuraFisica = this.estructuraFisica.idEstructuraFisica;
        registro.idEstructuraFisicaUsuarioProceso = this.estructurasFisicasUsuariosProcesosTodos.find((x) => x.idUsuarioProceso === idUsuarioProceso) ?  this.estructurasFisicasUsuariosProcesosTodos.find((x) => x.idUsuarioProceso === idUsuarioProceso).idEstructuraFisicaUsuarioProceso : null;
        registro.idUsuarioProceso = idUsuarioProceso;
        registroBulk.push(registro);
      })
      await this.guardarEstructuraFisicaUsuarioProcesos(registroBulk);

    }
  }

  async actualizarEstructuraFisica() {
    this.carInformacionInicial = true;
    this.busqueda = null;
    this.estructuraFisica.indicadorRestriccionAprobacion = this.isSwitchOn;
    await this.estructuraFisicaServicio.update(this.estructuraFisica).toPromise();
    if (this.isSwitchOn) {
      this.cargaInicialFinalizada ? await this.actualizarTablaYListados() : await this.cargarInformacionNivelAprobacion();
    }
    this.carInformacionInicial = false;
  }

  async cargarInformacionNivelAprobacion() {
    if (!this.estructuraFisica.indicadorRestriccionAprobacion) {
      return;
    }
    this.carInformacionInicial = true;
    this.carTabla = true;
    const [ usuariosProcesos, estructuraFisicaUsuariosProcesos ] = await forkJoin(
      this.usuariosProcesosService.listadoHabilitados(),
      this.estructuraFisicaUsuariosProcesosService.listadoPorIdEstructuraFisica(this.estructuraFisica.idEstructuraFisica)
    ).toPromise();
    this.lisUsuariosProcesosTodos = usuariosProcesos;
    this.estructurasFisicasUsuariosProcesosTodos = estructuraFisicaUsuariosProcesos;
    this.estructurasFisicasUsuariosProcesosFiltrados = this.estructurasFisicasUsuariosProcesosTodos.filter((x) => x.indicadorHabilitado);
    this.lisUsuariosProcesos = [];
    this.lisUsuariosProcesosTodos.map((usuarioProceso) => {
      if (usuarioProceso.idNivelRango && !this.estructurasFisicasUsuariosProcesosFiltrados.find((x) => x.idUsuarioProceso === usuarioProceso.idUsuarioProceso)) {
        this.lisUsuariosProcesos.push({label: usuarioProceso.usuarioSistema, value: usuarioProceso.idUsuarioProceso })
      }
    });
    this.cargarFormulario();
    this.cargaInicialFinalizada = true;
    this.carInformacionInicial = false;
    this.carTabla = false;
  }

  async actualizarTablaYListados() {
    this.carTabla = true;
    this.estructurasFisicasUsuariosProcesosTodos = await this.estructuraFisicaUsuariosProcesosService.listadoPorIdEstructuraFisica(this.estructuraFisica.idEstructuraFisica).toPromise();
    this.estructurasFisicasUsuariosProcesosFiltrados = this.estructurasFisicasUsuariosProcesosTodos.filter((x) => x.indicadorHabilitado);
    this.lisUsuariosProcesos = [];
    this.lisUsuariosProcesosTodos.map((usuarioProceso) => {
      if (usuarioProceso.idNivelRango && !this.estructurasFisicasUsuariosProcesosFiltrados.find((x) => x.idUsuarioProceso === usuarioProceso.idUsuarioProceso)) {
        this.lisUsuariosProcesos.push({label: usuarioProceso.usuarioSistema, value: usuarioProceso.idUsuarioProceso })
      }
    });
    this.cargarFormulario();
    this.formulario.reset();
    this.carTabla = false;
  }

  ver(regVer: Grupo) {
    this.router.navigate([
      "apl/estructura-fisica/asignar-grupo/detalle/" + regVer.idGrupo,
    ]);
  }

  editar(regActualizar: Grupo) {
    this.router.navigate([
      "apl/estructura-fisica/asignar-grupo/" +
        this.estructuraFisica.idEstructuraFisica +
        "/editar/" +
        regActualizar.idGrupo,
    ]);
  }

  setBusqueda() {
    this.navServicio.setSearch("asignar-grupos.component", this.busqueda);
  }

  get f() {
    return this.formulario.controls;
  }
}
